import { gql } from "@apollo/client";

export const CURRENT_AGREEMENT = gql`
  query currentAgreement($type: AgreementType!) {
    currentAgreement(input: { type: $type }) {
      id
      type
      version
      title
      url
    }
  }
`;
